import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { ISimulationCurveGraph, Simulation } from '../Simulation.ts';
import { SimulationApi } from '../../../apis/SimulationApi/SimulationApi.ts';
import { useSimulation } from '../../../hooks/useSimulation.tsx';

export function useDeleteSimulation() {
    const queryClient = useQueryClient();
    const { setSimulationCurveGraph } = useSimulation();

    return useMutation<number, AppMedError, string>({
        mutationKey: [QueryKeys.simulation, QueryKeys.defaultSimulation],
        mutationFn: async (entityId) => {
            await SimulationApi.deleteSimulation(entityId);
            queryClient.setQueryData<Simulation[]>([QueryKeys.simulation], (prev) => {
                return prev ? prev.filter((el) => el.id !== Number(entityId)) : [];
            });

            queryClient.setQueryData<Simulation>([QueryKeys.defaultSimulation], (prev) => {
                return prev
                    ? { ...prev, savedSimulations: prev.savedSimulations.filter((el) => el.id !== Number(entityId)) }
                    : prev;
            });

            queryClient.setQueryData<ISimulationCurveGraph | null>([QueryKeys.simulationCurveGraph], () => {
                setSimulationCurveGraph(null);
                return null;
            });

            return Number(entityId);
        },
        onError: (error) => {
            console.error('Erreur dans la mutation :', error);
        },
    });
}
